export default {
  state: {
    config: {},
    saas_data: {},
    ping: {},
    system: {},
    references: {}
  },
  mutations: {
    setConfig(state, value) {
      state.config = value
    },
    setLocalRefs(state, value){
      state.config = {...state.config, local_refs: value}
    },
    setConfigServer(state, value){
      state.config = {...state.config, config: value}
    },
    setSaasData(state, value) {
      state.saas_data = value
    },
    setPing(state, value) {
      state.ping = value
    },
    setSystem(state, value){
      state.system = value
    },
    setReferences(state, value){
      state.references = value
    }
  },
  actions: {
    async globalPing({dispatch, commit}) {
      return await commit('setPing', await dispatch('apiQuery', {method: "/ping"}))
    },
    async loadConfig({dispatch, commit}) {
      return await commit('setConfig', await dispatch('apiQuery', {method:"/config"}))
    },
    async updateConfig({dispatch, commit}, body) {
      return await commit('setConfig', await dispatch('apiQuery', {method: "/config", body}))
    },
    async updateLocalRefs({dispatch, commit}, body) {
      return await commit('setConfig', await dispatch('apiQuery', {method: "/refs", body}))
    },
    async loadSaasData({dispatch, commit}) {
      return await commit('setSaasData', await dispatch('apiQuery', {method: "/saasdata"}))
    },
    async updateSaasData({dispatch, commit}, body) {
      return await commit('setSaasData', await dispatch('apiQuery', {method: "/saasdata", body}))
    },
    async updateInstanceGuid({dispatch, commit}) {
      return await commit('setSaasData', await dispatch('apiQuery', {method: "/update_saas_instance_guid"}))
    },
    async updateSequenceNumber({dispatch, commit}) {
      return await commit('setSaasData', await dispatch('apiQuery', {method: "/update_saas_seqnumber"}))
    },
    async updateLicenseInfo({dispatch, commit}) {
      return await commit('setSaasData', await dispatch('apiQuery', {method: "/update_saas_license"}))
    },
    async loadSystemInfo({dispatch, commit}) {
      return await commit('setSystem', await dispatch('apiQuery', {method: "/sysinfo"}))
    },
    async loadReferences({dispatch, commit}) {
      return await commit('setReferences', await dispatch('apiQuery', {method: "/references"}))
    }
  },
  getters: {
    config(state){
      return state.config ? state.config.config : {}
    },
    local_refs(state){
      return state.config ? state.config.local_refs : {}
    },
    saas_data(state) {
      return state.saas_data
    },
    ping(state) {
      return state.ping
    },
    sysInfo(state) {
      return state.system
    },
    references(state) {
      return state.references
    },
    guest_discounts(state, getters) {
        let active_discounts = [{code: null, text: 'Без скидок'}]
        const discounts_ids = getters.config?.r_keeper_references.guest_discounts;

        if(Object.keys(getters.references).length) {
          getters.references.order_discount_ref.forEach(item => {
            if(discounts_ids.includes(item.value))
              active_discounts.push(item)
          });
        }

      return active_discounts
    }
  }

}